import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="social-links">
          <a href="https://x.com/lexBock" target="_blank" rel="noopener noreferrer" aria-label="Alex Bock on X (opens in a new tab)">X</a>
          <a href="https://github.com/bockengineering" target="_blank" rel="noopener noreferrer" aria-label="Alex Bock on GitHub (opens in a new tab)">GitHub</a>
          <a href="https://www.linkedin.com/in/alexbock" target="_blank" rel="noopener noreferrer" aria-label="Alex Bock on LinkedIn (opens in a new tab)">LinkedIn</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
